const initialState = {
  zoomLevel: null, // can be 200, 300, 400, or null
};

const SET_ZOOM = "SET_ZOOM";

export const setZoom = (payload) => ({
  type: SET_ZOOM,
  payload, // payload: 200 / 300 / 400 / null
});

const zoomReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ZOOM:
      return { ...state, zoomLevel: action.payload };
    default:
      return state;
  }
};

export default zoomReducer;